import { FormControlLabel, Switch } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';

const DevCoachingSwitch = ({ config }) => {
  const { devCoachingEnabled, isAdmin, toggleDevCoachingPermissions } = config;

  return (
    <Flex ml='0.3rem'>
      <FormControlLabel
        control={
          <Switch
            size='small'
            onClick={toggleDevCoachingPermissions}
            checked={devCoachingEnabled || isAdmin}
            disabled={isAdmin}
          />
        }
        label={
          <Text size='large' ml='1rem' color='shark'>
            Show Developer Coaching (For Contributors in Scope)
          </Text>
        }
      />
    </Flex>
  );
};

export default DevCoachingSwitch;
